import Joi from 'joi';

export const schema = Joi.object({
  password: Joi.string()
    .min(5)
    .error(new Error('La contraseña debe contar con más de 5 caracteres')),
  confirmationPassword: Joi.string()
    .min(5)
    .error(new Error('La contraseña debe contar con más de 5 caracteres')),
});
